import withOauthRouteHandling from '../../../decorators/auth/withOauthRouteHandling';
import {
  AUTHORIZE_PATH,
  AUTHORIZE_CONFIRM_PATH,
} from '../../../constants/paths';
import OauthAuthPageLoader from './OauthAuthPageLoader';

export default withOauthRouteHandling(
  OauthAuthPageLoader,
  AUTHORIZE_PATH,
  AUTHORIZE_CONFIRM_PATH,
);
